<template>
  <div>
    <c-card>
      <c-card-header>
        <c-icon name="cil-globe-alt" />
        Flags
      </c-card-header>
      <c-card-body>
        <c-row class="text-center">
          <c-col class="mb-5" col="12">
            <!-- For using the flags inline with text add the classes
            <code>.flag-icon</code> and <code>.flag-icon-xx</code>
            (where xx is the ISO 3166-1-alpha-2 code of a country) to an empty
            span. If you want to have a squared version flag then add the class
            flag-icon-squared as well. -->
          </c-col>
          <template v-for="(flag, flagName) in $options.flagSet">
            <c-col :key="flagName" class="mb-5" col="3" sm="2">
              <c-icon :height="42" :content="flag" />
              <div>{{ toKebabCase(flagName) }}</div>
            </c-col>
          </template>
        </c-row>
      </c-card-body>
    </c-card>
  </div>
</template>

<script>
import { flagSet } from '@coreui/icons';

export default {
  name: 'Flags',
  flagSet,
  methods: {
    toKebabCase(str) {
      return str.replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
    },
  },
};
</script>
